module.exports = __webpack_public_path__ + "src/assets/img/eda.4905696e.jpg";